import store from "@/store";
import { mapGetters } from "vuex";

export default {
    name: "SideBar",

    computed: {
        ...mapGetters({ adminToken: "adminToken" }),
    },

    methods: {
        logoutAdmin() {
            store.dispatch("adminLogout")
            .then(()=> {
                this.$router.push({ name: 'adminLogin' });
            })
            .catch((error) => {
                console.log(error);
                this.$router.push({ name: 'adminLogin' });
            });
        }
    }
};